var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M10 0c2.756 0 5.112.978 7.067 2.933C19.022 4.888 20 7.243 20 10c0 2.756-.978 5.112-2.933 7.067C15.112 19.022 12.757 20 10 20c-2.756 0-5.112-.978-7.067-2.933C.978 15.112 0 12.757 0 10c0-2.756.978-5.112 2.933-7.067C4.888.978 7.243 0 10 0zm0 19.183c2.82 0 5.16-1.106 7.02-3.318-1.38-.544-2.87-1.057-4.472-1.538-.096-.064-.144-.24-.144-.53 0-.223.112-.592.336-1.105.16-.32.305-.833.433-1.538.32-.385.545-.898.673-1.54.096-.576.096-1.024 0-1.345-.032-.033-.048-.065-.048-.097-.096-.32-.048-.93.144-1.827.16-.833-.08-1.667-.72-2.5-.61-.833-1.54-1.282-2.79-1.346h-.865c-1.25.096-2.18.545-2.788 1.346-.642.833-.883 1.667-.722 2.5.192.898.24 1.507.144 1.827v.096c-.128.384-.144.833-.048 1.345.16.673.384 1.202.673 1.587.128.64.272 1.138.433 1.49.128.257.192.64.192 1.154 0 .257-.048.417-.144.48-1.603.45-3.045.962-4.327 1.54 1.828 2.21 4.167 3.317 7.02 3.317z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.c50b3aece47d4d4d87ed48ea0d750064.svg";
export { ForwardRef as ReactComponent };